import Section from "../Section/Section";
import { CardWrapper, Grid } from "./Elements";
import SectionCard from "./SectionCard";
import recycleCard from "../../Images/recycle-card.png";
import bottlesCard from "../../Images/bottles-card.png";
const CimeSeBavimo = () => {
  const data = [
    {
      icon: "mdi:recycle",
      title: "Reciklaza staklenih boca",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Felis, at mauris risus et purus blandit netus gravida. Diam dictum sed at massa id id.",
      bg: recycleCard,
    },
    {
      icon: "mdi:bottle-wine",
      title: "Proizvodnja staklenih boca od recikliranog stakla",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Felis, at mauris risus et purus blandit netus gravida. Diam dictum sed at massa id id.",
      bg: bottlesCard,
    },
  ];
  return (
    <Section title="Cime se bavimo?">
      <Grid>
        {data.map((card, i) => {
          return (
            <SectionCard
              key={i}
              data={card}
              dataAos={i % 2 == 0 ? "fade-right" : "fade-left"}
            />
          );
        })}
      </Grid>
    </Section>
  );
};

export default CimeSeBavimo;
